import React, { useEffect, useState } from 'react'
import styles from "./Chat.module.scss";


export default function ReadFile({ blob, fileName, mimeType }: any) {
  const [fileSrc, setFileSrc] = useState<any>();
  const imageFileTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif"];

  useEffect(() => {
    setFileSrc(URL.createObjectURL(blob));
  }, [blob])

  return (
    imageFileTypes.includes(mimeType) ?
      <div className={styles.imgWrap}>
        <img src={fileSrc} alt={fileName} />
        <a style={{ color: "#ffff" }} href={fileSrc} download={fileName}>{fileName}</a>
      </div> :
      <a style={{ color: "#ffff" }} href={fileSrc} download={fileName}>{fileName}</a>
  )
}
